import DatePicker from './picker/date-picker';
import Time from './picker/time-picker';

export default DatePicker;
export const TimePicker = Time;
